(function () {
  'use strict';

  // Cache DOM references — populated lazily, only when needed
  let alertDropdown = null;
  let alertIcons = null;

  function getDropdown() {
    if (!alertDropdown) alertDropdown = document.getElementById('alertDropdown');
    return alertDropdown;
  }

  function getIcons() {
    if (!alertIcons) alertIcons = document.querySelectorAll('.alertnotifybutton');
    return alertIcons;
  }

  // ──────────────────────────────────────────────────────────────
  // Scroll handler — passive + throttled with rAF, no forced reflow
  // ──────────────────────────────────────────────────────────────
  let scrollScheduled = false;
  function onScroll() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      scrollScheduled = false;
      const dropdown = getDropdown();
      if (!dropdown || !dropdown.classList.contains('mobilestyle')) return;  // bail early
      dropdown.classList.remove('mobilestyle');
      dropdown.style.top = '';
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // ──────────────────────────────────────────────────────────────
  // Position adjustment — called only on toggle, NOT in a rAF loop
  // ──────────────────────────────────────────────────────────────
  function adjustPosition() {
    const element = document.querySelector('.header-sticky-added .alert-dropdown.mobilestyle');
    if (element) {
      element.style.top = `${(window.scrollY || window.pageYOffset) + 100}px`;
    }
  }

  // ──────────────────────────────────────────────────────────────
  // Notification state
  // ──────────────────────────────────────────────────────────────
  function getClickedItems() {
    try {
      return JSON.parse(localStorage.getItem('notificationItems')) || [];
    } catch (e) {
      return [];
    }
  }

  function saveClickedItem(itemId) {
    const items = getClickedItems();
    if (!items.includes(itemId)) {
      items.push(itemId);
      try { localStorage.setItem('notificationItems', JSON.stringify(items)); } catch (e) {}
    }
  }

  function updateAlertCount() {
    const alertIcon = document.getElementById('alertIcon');
    if (!alertIcon) return;
    alertIcon.textContent = document.querySelectorAll('.alert-list-item:not(.clicked)').length;
  }

  function updateRing() {
    const hasUnread = document.querySelector('.alert-list-item.new-notification') !== null;
    getIcons().forEach(icon => icon.classList.toggle('ringing', hasUnread));
  }

  function markAllItemsAsRead() {
    document.querySelectorAll('.alert-list-item.new-notification').forEach(item => {
      saveClickedItem(item.getAttribute('data-item'));
    });
  }

  function toggleAlertDropdown() {
    const dropdown = getDropdown();
    if (!dropdown) return;
    const willOpen = !dropdown.classList.contains('mobilestyle');
    dropdown.classList.toggle('mobilestyle', willOpen);
    if (willOpen) adjustPosition();  // ← only call when we actually open the dropdown
    getIcons().forEach(icon => icon.classList.remove('ringing'));
  }

  // Expose globals that inline onclick="" attributes might use
  window.toggleAlertDropdown = toggleAlertDropdown;
  window.toggleAlertDropdownFromIcon = toggleAlertDropdown;
  window.toggleDot = function (item) {
    const itemId = item.getAttribute('data-item');
    if (item.classList.contains('clicked') || getClickedItems().includes(itemId)) return;
    item.classList.add('clicked');
    item.classList.remove('new-notification');
    saveClickedItem(itemId);
    updateRing();
  };

  function restoreClickedItems() {
    const clicked = getClickedItems();
    if (clicked.length === 0) { updateRing(); return; }
    // Build a Set for O(1) lookup
    const clickedSet = new Set(clicked);
    document.querySelectorAll('.alert-list-item').forEach(item => {
      if (clickedSet.has(item.getAttribute('data-item'))) {
        item.classList.add('clicked');
        item.classList.remove('new-notification');
      }
    });
    updateRing();
  }

  // ──────────────────────────────────────────────────────────────
  // Init — wait for DOM, run once
  // ──────────────────────────────────────────────────────────────
function init() {
  restoreClickedItems();

  // ──────────────────────────────────────────────
  // CAPTURE-phase listener — for cart icon only
  // Runs BEFORE the cart's own click handler can stopPropagation()
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header-single-line__item--cart')) return;
    const dropdown = getDropdown();
    if (!dropdown) return;
    dropdown.classList.remove('mobilestyle');
    dropdown.style.top = '';
  }, true);  // ← capture phase, critical

  // ──────────────────────────────────────────────
  // BUBBLE-phase listener — bell icon + outside-click
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // Bell icon clicked
    const icon = e.target.closest('.alertnotifybutton');
    if (icon) {
      markAllItemsAsRead();
      toggleAlertDropdown();
      return;
    }

    // Outside-click → close dropdown
    const dropdown = getDropdown();
    if (dropdown && dropdown.classList.contains('mobilestyle') && !dropdown.contains(e.target)) {
      dropdown.classList.remove('mobilestyle');
      dropdown.style.top = '';
    }
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();